import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useSpecPartners() {
    const queryReturnValues = useQuery(
        ["specPartners"],
        inventoryClient.getSpecPartnersReactQuery,
        {
            staleTime: 5000
        }
    );

   return queryReturnValues;
}

export default useSpecPartners;